export default () => ({
  restrict: "A",
  link($scope, element, attrs) {
    const img = new Image();
    angular
      .element(img)
      .on("load", function () {
        element.css("background-image", "url(" + attrs.backgroundImage + ")");
      })
      .on("error", function () {
        element.css(
          "background-image",
          "url(" +
            (attrs.altImg ||
              "//placehold.it/720x720&text=Image Comming Soon!") +
            ")"
        );
        element.attr(
          "title",
          attrs.altImgTitle || "This image is coming soon!"
        );
      });
    img.src = attrs.backgroundImage;
  },
});
